export enum LoaderActionTypes {
  SHOW_LOADER = 'SHOW_LOADER',
  HIDE_LOADER = 'HIDE_LOADER',
}

export function showLoader() {
  return { type: LoaderActionTypes.SHOW_LOADER };
}

export function hideLoader() {
  return { type: LoaderActionTypes.HIDE_LOADER };
}
